import { PASSWORD_RULES } from "@etudescarre/constants";
import { cn } from "@etudescarre/ui";

const criteria = [
  {
    label: `Au moins ${PASSWORD_RULES.minLength} caractères`,
    test: (p: string) => p.length >= PASSWORD_RULES.minLength,
  },
  { label: "Au moins 1 majuscule", test: (p: string) => /[A-Z]/.test(p) },
  { label: "Au moins 1 minuscule", test: (p: string) => /[a-z]/.test(p) },
  { label: "Au moins 1 chiffre", test: (p: string) => /\d/.test(p) },
];

export interface PasswordCriteriaProps {
  /** Referenced by the password input's `aria-describedby`. */
  id: string;
  password: string;
  /** Turns the unmet criteria red, once a submit was refused. */
  showErrors?: boolean;
}

export function PasswordCriteria({
  id,
  password,
  showErrors = false,
}: PasswordCriteriaProps) {
  return (
    <div className="mt-2 space-y-1" id={id}>
      <p className="text-gray-600 text-sm">
        {`Minimum ${PASSWORD_RULES.minLength} caractères, dont au moins 1 majuscule, 1 minuscule et 1 chiffre.`}
      </p>
      <ul className="space-y-1">
        {criteria.map(({ label, test }) => {
          const valid = test(password);
          return (
            <li
              className={cn(
                "flex items-center gap-2 text-sm",
                valid
                  ? "text-green-600"
                  : showErrors
                    ? "text-red-600"
                    : "text-gray-400",
              )}
              key={label}
            >
              <span aria-hidden className="font-bold">
                {valid ? "✓" : "·"}
              </span>
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
